const STORAGE_KEY = 'ad_attribution';
const TTL_MS = 90 * 24 * 60 * 60 * 1000;

export interface AdAttribution {
  gclid?: string;
  gbraid?: string;
  wbraid?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  landing_page_url?: string;
  referrer?: string;
  captured_at?: string;
}

export function captureAttribution(): void {
  try {
    if (localStorage.getItem(STORAGE_KEY)) return;

    const p = new URLSearchParams(window.location.search);
    const data: AdAttribution & { _expires: number } = {
      ...(p.get('gclid') && { gclid: p.get('gclid')! }),
      ...(p.get('gbraid') && { gbraid: p.get('gbraid')! }),
      ...(p.get('wbraid') && { wbraid: p.get('wbraid')! }),
      ...(p.get('utm_source') && { utm_source: p.get('utm_source')! }),
      ...(p.get('utm_medium') && { utm_medium: p.get('utm_medium')! }),
      ...(p.get('utm_campaign') && { utm_campaign: p.get('utm_campaign')! }),
      ...(p.get('utm_term') && { utm_term: p.get('utm_term')! }),
      ...(p.get('utm_content') && { utm_content: p.get('utm_content')! }),
      landing_page_url: window.location.href,
      ...(document.referrer && { referrer: document.referrer }),
      captured_at: new Date().toISOString(),
      _expires: Date.now() + TTL_MS,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch { /* storage unavailable */ }
}

export function getAttribution(): AdAttribution | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const { _expires, ...attribution } = JSON.parse(raw);
    if (Date.now() > _expires) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return attribution as AdAttribution;
  } catch {
    return null;
  }
}
